import React from 'react';
import { CommercialMessage, VoucherModal } from '@pegasus/commercial-messages';

import { track } from '@client/helpers/tracking';
import { trackEvents } from '@client/components/mylounge/constants';
import { ErrorBoundary } from '@browsing/components';

import useCustomCommercialMessage from '../use-commercial-message';
import { useCommercialMessageVisibility } from './use-commercial-message-visibility';

// TODO: this component is extracted for clarity
// investigation is required to understand if it is removable
// https://jira.zalando.net/browse/LACT-933
export const InternalCommercialMessageContainer = () => {
    const commercialMessage = useCustomCommercialMessage();
    const { showCommercialMessageModal } = useCommercialMessageVisibility();

    if (!showCommercialMessageModal) {
        return null;
    }

    return (
        <CommercialMessage
            component={VoucherModal}
            event={commercialMessage.event}
            onClose={commercialMessage.onClose}
            onRedeem={commercialMessage.onRedeem}
            track={track}
            trackEvents={trackEvents}
        />
    );
};

export const CommercialMessageContainer: React.FC = () => (
    <ErrorBoundary componentName="MyLoungeCommercialMessage">
        <InternalCommercialMessageContainer />
    </ErrorBoundary>
);
